<template>
  <div class="navbar-container d-flex content align-items-center flex-nowrap app-navbar-vertical">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none flex-shrink-0 app-navbar-menu-toggle">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col — page title (desktop); on mobile punch fills this flex space via actions row -->
    <div class="bookmark-wrapper d-none d-lg-flex align-items-center flex-grow-1 min-w-0">

      <!-- Current page title — replaces the old Calendar/Todo/Policy
           Documents quick-link icons (`<bookmarks />`) in this same slot,
           per product direction. See `PageTitle.vue` for the fallback
           chain if a route has no `meta.pageTitle`. -->
      <page-title />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto flex-nowrap app-navbar-actions">
      <!-- Single punch instance: compact on ≤767 via PunchAttendance CSS -->
      <punch-attendance v-if="$can('create', 'punch_attendance')" />
      <dark-toggler class="d-none d-lg-block" />
      
      <!--<search-bar />-->
      <!--<cart-dropdown />-->
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<style scoped>
/* Mobile row: menu | punch | bell + avatar — no wrap / no stack */
@media (max-width: 767px) {
  .app-navbar-vertical {
    flex-wrap: nowrap !important;
    gap: 0.15rem;
    min-width: 0;
  }

  .app-navbar-menu-toggle {
    flex-flow: row nowrap !important;
    margin: 0 !important;
  }

  .app-navbar-menu-toggle .nav-link {
    padding-left: 0.35rem;
    padding-right: 0.35rem;
    min-height: 2.25rem;
    display: inline-flex;
    align-items: center;
  }

  .app-navbar-actions {
    flex: 1 1 auto;
    flex-flow: row nowrap !important;
    flex-wrap: nowrap !important;
    justify-content: flex-end;
    align-items: center;
    min-width: 0;
    margin-left: 0.25rem !important;
    gap: 0.1rem;
  }

  .app-navbar-actions >>> .nav-item,
  .app-navbar-actions >>> .dropdown {
    float: none !important;
    flex-shrink: 0;
  }

  .app-navbar-actions >>> .punch-attendance-buttons {
    flex: 1 1 auto;
    min-width: 0;
    justify-content: flex-start;
    margin-right: 0.35rem;
  }

  .app-navbar-actions >>> .dropdown-notification,
  .app-navbar-actions >>> .dropdown-user {
    flex-shrink: 0;
  }

  .app-navbar-actions >>> .nav-link {
    padding-left: 0.4rem;
    padding-right: 0.4rem;
  }
}
</style>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import PageTitle from './components/PageTitle.vue'
// import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import PunchAttendance from './components/PunchAttendance.vue'
// import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    PageTitle,
    // Locale,
    SearchBar,
    DarkToggler,
    PunchAttendance,
    // CartDropdown,
    NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
